@import "../conversational-search-banners/simple-banner/simple-banner.scss";
@import "../conversational-search-banners/large-banner/large-banner.scss";
@import "../../../../styles/variables";

.conversational-search-banner-mediator {
  &--hidden {
    display: none;
  }
}
